import React from 'react';
import { Link } from 'react-router-dom';
import './OurInsight.css';

const OurInsight = ({
  badge,
  heading,
  description,
  imageUrl,
  imageAlt,
  floatingTag,
  ctaText,
  ctaLink = "#enquiry-form-section"
}) => {
  if (!heading && !description) return null;

  const handleScroll = (e) => {
    if (ctaLink && ctaLink.startsWith("#")) {
      e.preventDefault();
      const targetId = ctaLink.replace("#", "");
      const targetElement = document.getElementById(targetId);
      if (targetElement) {
        targetElement.scrollIntoView({ behavior: "smooth" });
      }
    }
  };

  return (
    <section className="our-insight-section">
      <div className="our-insight-container">
        
        {/* Main Showcase Card */}
        <div className={`our-insight-card ${!imageUrl ? 'no-image' : ''}`}>
          
          {/* Top Hover Accent Bar */}
          <div className="our-insight-hover-bar"></div>

          {/* LEFT SIDE: Visual Showcase */}
          {imageUrl && (
            <div className="our-insight-visual">
              <div className="our-insight-image-wrapper">
                <img 
                  src={imageUrl} 
                  alt={imageAlt || heading || "Institutional Insight"} 
                  className="our-insight-image"
                  loading="lazy"
                />
                <div className="our-insight-image-overlay"></div>

                {floatingTag && (
                  <div className="our-insight-floating-pill">
                    <span className="our-insight-pulse-dot"></span>
                    <span>{floatingTag}</span>
                  </div>
                )}
              </div>
            </div>
          )}

          {/* RIGHT SIDE: Content Column */}
          <div className="our-insight-content">
            
            {/* Header Eyebrow with Left & Right Dashes */}
            {badge && (
              <div className="our-insight-eyebrow">
                <span className="our-insight-eyebrow-dash"></span>
                <span>{badge}</span>
                <span className="our-insight-eyebrow-dash"></span>
              </div>
            )}

            {/* Main Bold Heading */}
            {heading && (
              <h2 className="our-insight-heading">
                {heading}
              </h2>
            )}

            {/* Narrative Description */}
            {description && (
              <p className="our-insight-description">
                {description}
              </p>
            )}

            {/* Explore Link / CTA */}
            {ctaText && (
              <div className="our-insight-action">
                {ctaLink && ctaLink.startsWith("#") ? (
                  <a 
                    href={ctaLink} 
                    onClick={handleScroll} 
                    className="our-insight-cta-link"
                  >
                    <span>{ctaText}</span>
                    <svg 
                      className="our-insight-arrow-icon"
                      width="18" 
                      height="18" 
                      viewBox="0 0 24 24" 
                      fill="none" 
                      stroke="currentColor" 
                      strokeWidth="2.4" 
                      strokeLinecap="round" 
                      strokeLinejoin="round"
                    >
                      <line x1="5" y1="12" x2="19" y2="12"></line>
                      <polyline points="12 5 19 12 12 19"></polyline>
                    </svg>
                  </a>
                ) : (
                  <Link 
                    to={ctaLink || "#"} 
                    className="our-insight-cta-link"
                  >
                    <span>{ctaText}</span>
                    <svg 
                      className="our-insight-arrow-icon"
                      width="18" 
                      height="18" 
                      viewBox="0 0 24 24" 
                      fill="none" 
                      stroke="currentColor" 
                      strokeWidth="2.4" 
                      strokeLinecap="round" 
                      strokeLinejoin="round"
                    >
                      <line x1="5" y1="12" x2="19" y2="12"></line>
                      <polyline points="12 5 19 12 12 19"></polyline>
                    </svg>
                  </Link>
                )}
              </div>
            )}

          </div>

        </div>

      </div>
    </section>
  );
};

export default OurInsight;